import { FormHelperText, Grid, Rating } from "@mui/material";
import { MprcContainer, MprcStringToHtml } from "components";
import { MprcNumberField } from "components/MprcNumberField";
import { ManagedQuestionResponse } from "generated/CoreApi_v1";
import React from "react";
import { useTranslation } from "react-i18next";
import { useQuestionContext } from "views/assessment/questionBank/Home/EditQuestion/EditQuestion";
import { PointTypedButton } from "views/assessment/questionBank/components/QuestionCommon";

/////////////////////////////////////////////////////////////////////////////////

export interface IPostValidationStar {
    alternatives: string[] | undefined;
}

export interface IValidationFieldsStar {
    alternatives: boolean;
}

///
export function validateStar(dto: ManagedQuestionResponse): IValidationFieldsStar {
    return {
        alternatives: dto.survey?.pointTyped == false
            || !dto.alternatives.some(x => (x.survey?.points ?? 0) == 0 || (x.survey?.points ?? 0) > 1000)
    };
}

/////////////////////////////////////////////////////////////////////////////////

export const EditQuestionStar: React.FC = () => {

    const { viewData, postValidation, readonly, handleUpdateRecord, handleUpdateSurvey } = useQuestionContext();

    const { t } = useTranslation("assessment");

    const currentPostValidation = postValidation.alternativeBox;

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <>
            <Grid container>
                <Grid size="grow">&nbsp;</Grid>
                <Grid>
                    <PointTypedButton
                        tooltip={t("Question.Edit.Alternative.PointTypedTooltip")}
                        active={viewData.survey?.pointTyped ?? false}
                        readonly={readonly}
                        onClick={() => handleUpdateSurvey("pointTyped", !viewData.survey?.pointTyped)}
                    />
                </Grid>
            </Grid>
            <MprcContainer>
                {
                    viewData.survey?.pointTyped
                        ?
                        viewData.alternatives.map((v, index) => {
                            return (
                                <Grid key={v.alternativeId} container alignContent="center" alignItems="flex-start" spacing={1}>
                                    <Grid size="grow">
                                        <Rating
                                            name="read-only"
                                            value={5 - index}
                                            readOnly
                                        />
                                    </Grid>
                                    <Grid>
                                        <MprcNumberField
                                            value={viewData.alternatives[index].survey?.points}
                                            sx={{ width: 100 }}
                                            max={1000}
                                            onChange={value => {
                                                var newAlternatives = [...viewData.alternatives];
                                                newAlternatives[index].survey!.points = value ?? 0;
                                                handleUpdateRecord("alternatives", newAlternatives);
                                            }}
                                            slotProps={{ input: { endAdornment: t("Question.Edit.Alternative.PointsLabel") } }}
                                        />
                                    </Grid>
                                </Grid>
                            );
                        })
                        :
                        <Rating
                            name="read-only"
                            readOnly
                        />
                }
                {
                    !!currentPostValidation.alternatives &&
                    <FormHelperText error>{<MprcStringToHtml text={currentPostValidation?.alternatives} />}</FormHelperText>
                }

            </MprcContainer>
        </>
    );
};
